import { useDragAndDropEditorContext } from 'modules/dragAndDropEditor/context';
import { Button } from 'ui/button';
import { BUTTON_SIZES, BUTTON_VARIANTS } from 'ui/button/constants';
import { Modal, MODAL_SIZES, MODAL_VARIANTS, ModalBody, ModalFooter, ModalHeader } from 'ui/modal';

export const DISPLAY_CONTENT = {
  saveAndContinue: 'Save and continue',
  continueWithoutSaving: 'Continue without saving',
  headerContent: 'Warning',
  bodyContent: 'This template has been edited. Do you want to save your changes?',
} as const;

export const SAVED_ROW_TEMPLATE_WARNING_MODAL_TEST_ID = 'saved-row-template-warning-modal';
export const SAVED_ROW_TEMPLATE_WARNING_MODAL_SAVE_BUTTON_TEST_ID = `${SAVED_ROW_TEMPLATE_WARNING_MODAL_TEST_ID}-save-button`;
export const SAVED_ROW_TEMPLATE_WARNING_MODAL_DISCARD_BUTTON_TEST_ID = `${SAVED_ROW_TEMPLATE_WARNING_MODAL_TEST_ID}-discard-button`;

export type SavedRowUnsavedTemplateChangesWarningProps = {
  onClose: () => void;
  onContinueWithoutSaving: () => void;
  onSaveAndContinue: () => void;
};

export const SavedRowUnsavedTemplateChangesWarning = ({
  onSaveAndContinue,
  onClose,
  onContinueWithoutSaving,
}: SavedRowUnsavedTemplateChangesWarningProps) => {
  const { isSavingTemplateForSavedRow } = useDragAndDropEditorContext();

  return (
    <Modal
      withPortal
      isModalOpen
      onClose={onClose}
      size={MODAL_SIZES.SMALL}
      variant={MODAL_VARIANTS.WARNING}
      data-test={SAVED_ROW_TEMPLATE_WARNING_MODAL_TEST_ID}
      id={SAVED_ROW_TEMPLATE_WARNING_MODAL_TEST_ID}
    >
      <ModalHeader autoFocus={false}>{DISPLAY_CONTENT.headerContent}</ModalHeader>
      <ModalBody>{DISPLAY_CONTENT.bodyContent}</ModalBody>
      <ModalFooter>
        <Button
          onClick={onContinueWithoutSaving}
          size={BUTTON_SIZES.LARGE}
          variant={BUTTON_VARIANTS.SECONDARY}
          data-test={SAVED_ROW_TEMPLATE_WARNING_MODAL_DISCARD_BUTTON_TEST_ID}
        >
          {DISPLAY_CONTENT.continueWithoutSaving}
        </Button>
        <Button
          onClick={onSaveAndContinue}
          size={BUTTON_SIZES.LARGE}
          data-test={SAVED_ROW_TEMPLATE_WARNING_MODAL_SAVE_BUTTON_TEST_ID}
          isLoading={isSavingTemplateForSavedRow}
        >
          {DISPLAY_CONTENT.saveAndContinue}
        </Button>
      </ModalFooter>
    </Modal>
  );
};
